import {madnes_generate_frame_names} from "../framework/src/engine/madnes/madnes_anims";
import {madnes_set_visible} from "../framework/src/engine/madnes/madnes_object";
import {print_reels} from "./ps_core_printer";
import {server_config} from "../framework/src/engine/madnes/madnes_variables";

export const smybols_offset_top = 16;
// var lines = new Array();
export const cylinder_pos = [];
cylinder_pos[0] = 50;
cylinder_pos[1] = 280;
cylinder_pos[2] = 508;
cylinder_pos[3] = 736;
cylinder_pos[4] = 966;


var winAnimFrames = 59;
var standAnimFrames = 44;
var tdAnimFrames = 7;

export const icons = {
    "symbol_Devil": {
        "anim": madnes_generate_frame_names("symbol-Devil_", 0, winAnimFrames, "", 5),
        "stand": madnes_generate_frame_names("symbol-Devil_standing_", 0, standAnimFrames, "", 5),
        "touchdown": madnes_generate_frame_names("symbol-Devil_touchdown_", 0, tdAnimFrames, "", 5),
        "flyout": madnes_generate_frame_names("symbol-Devil_touchdown_", tdAnimFrames, 0, "", 5),
    },

    "symbol_King": {
        "anim": madnes_generate_frame_names("symbol-King_", 0, winAnimFrames, "", 5),
        "stand": madnes_generate_frame_names("symbol-King_standing_", 0, standAnimFrames, "", 5),
        "touchdown" : madnes_generate_frame_names("symbol-King_touchdown_", 0, tdAnimFrames, "", 5),
        "flyout" : madnes_generate_frame_names("symbol-King_touchdown_", tdAnimFrames, 0, "", 5),
    },

    "symbol_Knight": {
        "anim": madnes_generate_frame_names("symbol-Knight_", 0, winAnimFrames, "", 5),
        "stand": madnes_generate_frame_names("symbol-Knight_standing_", 0, standAnimFrames, "", 5),
        "touchdown" : madnes_generate_frame_names("symbol-Knight_touchdown_", 0, tdAnimFrames, "", 5),
        "flyout" : madnes_generate_frame_names("symbol-Knight_touchdown_", tdAnimFrames, 0, "", 5),
    },

    "symbol_Mystery": {
        "anim": madnes_generate_frame_names("symbol-Witch_", 0, winAnimFrames, "", 5),
        "stand": madnes_generate_frame_names("symbol-Witch_standing_", 0, standAnimFrames, "", 5),
        "touchdown" : madnes_generate_frame_names("symbol-Witch_touchdown_", 0, tdAnimFrames, "", 5),
        "flyout" : madnes_generate_frame_names("symbol-Witch_touchdown_", tdAnimFrames, 0, "", 5),
    },

    "symbol_Nix": {
        "anim": madnes_generate_frame_names("symbol-Nix_", 0, winAnimFrames, "", 5),
        "stand": madnes_generate_frame_names("symbol-Nix_standing_", 0, standAnimFrames, "", 5),
        "touchdown" : madnes_generate_frame_names("symbol-Nix_touchdown_", 0, tdAnimFrames, "", 5),
        "flyout" : madnes_generate_frame_names("symbol-Nix_touchdown_", tdAnimFrames, 0, "", 5),
    },

    "symbol_Princess": {
        "anim": madnes_generate_frame_names("symbol-Princess_", 0, winAnimFrames, "", 5),
        "stand": madnes_generate_frame_names("symbol-Princess_standing_", 0, standAnimFrames, "", 5),
        "touchdown" : madnes_generate_frame_names("symbol-Princess_touchdown_", 0, tdAnimFrames, "", 5),
        "flyout" : madnes_generate_frame_names("symbol-Princess_touchdown_", tdAnimFrames, 0, "", 5),
    },

    "symbol_Queen": {
        "anim": madnes_generate_frame_names("symbol-Queen_", 0, winAnimFrames, "", 5),
        "stand": madnes_generate_frame_names("symbol-Queen_standing_", 0, standAnimFrames, "", 5),
        "touchdown" : madnes_generate_frame_names("symbol-Queen_touchdown_", 0, tdAnimFrames, "", 5),
        "flyout" : madnes_generate_frame_names("symbol-Queen_touchdown_", tdAnimFrames, 0, "", 5),
    },

    "symbol_Scatter": {
        "anim": madnes_generate_frame_names("symbol-Clown_", 0, winAnimFrames, "", 5),
        "stand": madnes_generate_frame_names("symbol-Clown_standing_", 0, standAnimFrames, "", 5),
        "touchdown" : madnes_generate_frame_names("symbol-Clown_touchdown_", 0, tdAnimFrames, "", 5),
        "flyout" : madnes_generate_frame_names("symbol-Clown_touchdown_", tdAnimFrames, 0, "", 5),
    },

    "symbol_Wild": {
        "anim": madnes_generate_frame_names("symbol-Wild_", 0, winAnimFrames, "", 5),
        "stand": madnes_generate_frame_names("symbol-Wild_standing_", 0, standAnimFrames, "", 5),
        "touchdown" : madnes_generate_frame_names("symbol-Wild_touchdown_", 0, tdAnimFrames, "", 5),
        "flyout" : madnes_generate_frame_names("symbol-Wild_touchdown_", tdAnimFrames, 0, "", 5),
    },

    "symbol_Wild_to_symbol_Devil": {
        "anim": madnes_generate_frame_names("symbol-Wild_to_Devil_", 0, winAnimFrames, "", 5)
    },

    "symbol_Wild_to_symbol_King": {
        "anim": madnes_generate_frame_names("symbol-Wild_to_King_", 0, winAnimFrames, "", 5)
    },

    "symbol_Wild_to_symbol_Knight": {
        "anim": madnes_generate_frame_names("symbol-Wild_to_Knight_", 0, winAnimFrames, "", 5)
    },

    "symbol_Wild_to_symbol_Nix": {
        "anim": madnes_generate_frame_names("symbol-Wild_to_Nix_", 0, winAnimFrames, "", 5)
    },

    "symbol_Wild_to_symbol_Princess": {
        "anim": madnes_generate_frame_names("symbol-Wild_to_Princess_", 0, winAnimFrames, "", 5),
    },

    "symbol_Wild_to_symbol_Queen": {
        "anim": madnes_generate_frame_names("symbol-Wild_to_Queen_", 0, winAnimFrames, "", 5),
    }
};

export const symbols = [];
symbols[0] = -1;
symbols[1] = -1;
symbols[2] = -1;
symbols[3] = -1;
symbols[4] = -1;

export const icons_tmp = [];

export const last_symbol = [];
last_symbol[0] = -1;
last_symbol[1] = -1;
last_symbol[2] = -1;
last_symbol[3] = -1;
last_symbol[4] = -1;


//
// function init_game(dname, config, ver)
// {
// 	madnes_game_title = "PUPPET SHOW";
//
// 	madnes_set_texture_version(ver);
// 	madnes_load_init("puppet_show", config);
//
// 	madnes_config_load_symbols = false;
//
// 	//madnes_bar_color_1 = "#F30000";
//
// 	madnes_set_ico_size(258, 258 - 50);
//
//
// 	madnes_set_win_factors(25, 50, 125);
// 	madnes_set_native_sceen_size(1280, 720);
//
// 	for(var i in to_load_json)
// 	{
// 		if(infotexts_languages.indexOf(lang) === -1)
// 		{
// 			to_load_json[i] = to_load_json[i].replace("{l}", def_lang);
// 		}
//
// 		madnes_add_json(i, to_load_json[i]);
// 	}
//
// 	for(var i in to_load_audio)
// 	{
// 		madnes_add_audio(i, to_load_audio[i]);
// 	}
//
// 	for(var i in to_load)
// 	{
// 		madnes_add_to_load(i, to_load[i]);
// 	}
//
// 	for(var i in to_load_json_atlas)
// 	{
// 		madnes_add_json_atlas_to_load(i, to_load_json_atlas[i][0], to_load_json_atlas[i][1]);
// 	}
//
// 	for(var i in to_load_fonts)
// 	{
// 		madnes_add_font_to_load(i, to_load_fonts[i]);
// 	}
//
// //	var timestle = {
// //		'font': "20px Arial",
// //		'fill': "#FFFFFF",
// //		'align': "left",
// //		'boundsAlignH': "left",
// //		'boundsAlignV': "top",
// //		'wordWrap': false,
// //		'wordWrapWidth': 300
// //	};
//
// 	madnes_show_money_anim_callback_timeout = 40;
//
// 	madnes_set_sprite('_sprite', 258, 258);
// 	madnes_set_sprite('_blur', 258, 258);
// 	madnes_set_sprite('_sheet', 258, 258);
// 	madnes_set_sprite('_touchdown', 258, 258);
// 	madnes_set_sprite('_standing', 258, 258);
// 	madnes_set_sprite('_to_symbol_', 258, 258);
//
// 	madnes_set_sprite('mystery_btn_choose', 216, 86);
//
// 	//madnes_set_default_volume(0.8);
//
// 	madnes_set_sound_config_function(set_sounds);
// 	madnes_set_printdesk_function(print_desk);
// 	madnes_set_updatedesk_function(update_desk);
// 	madnes_set_rotate_function(rotate_run);
//
// 	/*madnes_set_betmenu_open_function(function() {
// 		end_standing_symbols();
// 	});
//
// 	madnes_set_betmenu_close_function(function() {
// 		start_standing_symbols();
// 	});
//
// 	madnes_set_autospin_open_function(function() {
// 		end_standing_symbols();
// 	});
//
// 	madnes_set_autospin_close_function(function() {
// 		start_standing_symbols();
// 	});*/
//
// 	//madnes_set_infomenu_init_function(infomenu_init);
// 	madnes_set_infomenu_open_function(infomenu_open);
// 	madnes_set_infomenu_close_function(infomenu_close);
// 	madnes_set_infomenu_update_function(infomenu_update);
// 	madnes_set_infomenu_left_function(infomenu_left);
// 	madnes_set_infomenu_right_function(infomenu_right);
//
// 	madnes_set_coin_values_init(function(currency)
// 	{
// 		if(currency === "PLN")
// 		{
// 			coin_values = [0.1, 1];
// 		}
// 		else
// 		{
// 			madnes_coin_values_init(currency);
// 		}
// 	});
//
// //	madnes_set_bets_init(function(currency)
// //	{
// //		if(currency === "PLN")
// //		{
// //			bets = [10];
// //		}
// //	});
//
// 	madnes_set_on_rotate_release(rotate_release);
// 	madnes_set_on_forcestop_press(forcestop_press);
//
// 	madnes_init(dname);
// }
// window['init_game'] = init_game;
//

export function update_desk() {

    print_reels();

    for(var i = 0; i < cylinder_pos.length; i++)
    {
        for(var j in server_config.logic.reels[i])
        {
            madnes_set_visible("reels_bufer_" + i + "_" + j, false);
        }
    }
}
